import styled from "@emotion/styled"
import Background from '../../../assets/background.jpg';

export const LoaderContainer  = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display:flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    background-image: ${ props => props.noBg ? 'none' : `url(${Background});`}; 
    background-repeat: no-repeat;
    background-position: bottom center;
    background-size: cover;
    background-attachment: fixed;
    background-color: ${ props => props.bgColor ? props.bgColor : 'transparent'};
    z-index: 2;
    pointer-events: all;
    > div {
        position: absolute;
        top: ${ props => props.top ? props.top : '20%'}; 
    }
`;
